const fromStringToBoolean = val => {
	if (val === 'true') return true
	if (val === 'false') return false
	return new Error('not a boolean')
}

export default fromStringToBoolean
